import type { DRSRoute, NavigationGroup, NavigationItem, NavigationRow } from "../types/drs";

export const createNavigationItem = (route: DRSRoute): NavigationItem => {
  return {
    title: route.name,
    icon: route.icon,
    launchPoint: route.launch_point,
    path: route.path,
    isRedirect: route.is_redirect,
  };
};

export const createNavigation = (drsRoutes: DRSRoute[]) => {
  const navigationRows: NavigationRow[] = [];

  drsRoutes.forEach((route) => {
    if (!route.attached_to_menu) return;

    const item = createNavigationItem(route);

    if (!route.navigation_group) {
      navigationRows.push(item);
      return;
    }

    const navigationGroup = navigationRows.find((item) => {
      if ("launchPoint" in item) return false;

      return item.name === route.navigation_group.name;
    }) as NavigationGroup;

    if (navigationGroup) {
      navigationGroup.items.push(item);
      return;
    }

    navigationRows.push({
      name: route.navigation_group.name,
      icon: route.navigation_group.icon,
      items: [item],
    });
  });

  return navigationRows;
};
